export default __webpack_public_path__ + "static/media/success.438b4cef.gif";